
import { Component, Mixins } from 'vue-property-decorator';
import Page from '@/views/Page.vue';
import { AuthMixin, BAIconsMixin, PurchaseMixin, StatusMixin, FormRulesMixin, AdminRoutingMixin, PaginatedTableMixin, MindsetDisplayMixin, ColorMixin } from '@/mixins';
import { DataTableHeader } from 'vuetify';
import { BAEventModel, EventTicketModel, EventParticipantDetails, EventLocationModel } from '@/models/baEvent';
import { BAEventDetail } from '@/../types/constants/admin.routes'
import BAEventShare from '@/views/admin/BAEventShare.vue'
import BAEventInvite from '@/views/admin/BAEventInvite.vue'
import TimePickerDialog from "@/components/calendar/TimePickerDialog.vue";
import FileUploadArea from '@/components/forms/FileUploadArea.vue';
import BAEventParticipants from '@/components/events/BAEventParticipants.vue';
import { AthleteProfileModel, BAPurchaseModel, CoachProfileModel } from '@/models';
import { TeamModel } from '@/models/team';
import { AgreementFile } from '@/models/file/FileModel';
import { ObjectCache } from '@/helpers/object-cache';
import { notificationStore } from '@/store';
import { baPurchaseApi } from '@/api/BAPurchaseApi';
import { CouponDiscountType, EventTicketCoupon } from '@/models/baEvent/BAEventModel';
import { RepositoryQuery } from '@/../types';

import { athleteApi } from '@/api/AthleteApi';
import { coachApi } from '@/api/CoachApi';
import { baEventApi, eventLocationApi } from '@/api/BAEventsApi';

import { cloneDeep } from 'lodash';

@Component({
	components: {
		Page,
        TimePickerDialog,
        FileUploadArea,
        BAEventShare,
        BAEventInvite,
        BAEventParticipants,
	}
})
export default class BAEventAdminDetailPage extends Mixins(BAIconsMixin, AuthMixin, FormRulesMixin, StatusMixin, PurchaseMixin, AdminRoutingMixin, PaginatedTableMixin, MindsetDisplayMixin, ColorMixin) {
    loadingEvent: boolean = true;
    savingEvent: boolean = false;
    baEvent: BAEventModel = new BAEventModel;
    editEvent: BAEventModel = new BAEventModel;
    selectLocation: EventLocationModel = new EventLocationModel;
    unlimitedCapacity: boolean;
    showBARating: boolean = false;

    CouponDiscountType = CouponDiscountType;

    get IsLoading(): boolean {
        return this.loadingEvent || this.savingEvent;
    }

    get TicketHeaders(): DataTableHeader<any>[] {
        return [
            {text: 'Name', value: 'name'},
			{text: 'Price $CAD', width:"150", value: 'PriceCAD'},
			{text: 'Price $US', width:"150", value: 'PriceUS'},
			{text: 'Available', width:"100", value: 'Remaining', sortable: false},
			{text: 'Capacity', width:"100", value: 'Capacity', sortable: false},
            {text: 'ID', width:"50", value: 'id', sortable: false},
            {text: "StripeID", width:"50", value: 'stripeId', sortable: false},
            {text: '', width:"50", value: 'actions', sortable: false},
        ]
    }
    get CoachHeaders(): DataTableHeader<any>[] {
        return [
            {text: 'Name', value: 'name', sortable: false},
            {text: 'Email', value: 'email', sortable: false},
            {text: 'ID', value: 'id', sortable: false},
            {text: '', width:"50", value: 'actions', sortable: false},
        ]
    }
    get DataLabelsHeaders(): DataTableHeader<any>[] {
        return [
            {text: 'Label', value: 'label', sortable: false },
            {text: '', width:"50", value: 'actions', sortable: false},
        ]
    }

    groupFilter: string = '';
    participants: EventParticipantDetails[] = [];
    searchParticipants: string = "";
    async updateParticipantsSearch(search: string) {
        this.searchParticipants = search;
        this.updateSearch();
    }
	get TotalItems(): number {
        return this.baEvent.participants.length;
	}

    loadStatus: string = "";
    async loadParticipants() {
        if( this.IsEmpty(this.baEvent) ) return;
        if( !this.viewParticipants ) return;

        this.dataItems = [];
        this.dataItemsCount = undefined;

	    // filter participants
        if( this.IsNotEmpty(this.searchParticipants) && this.IsNotEmpty(this.participants) ) {
            const filteredParticipants: Array<EventParticipantDetails> = this.participants.filter(p => (this.IsNotEmpty(p.tags) && p.tags.includes(this.searchParticipants.toLowerCase().trim())));
            this.dataItems = filteredParticipants;
            this.dataItemsCount = filteredParticipants.length;
            return;
        }

        const participantsToDisplay = this.baEvent.participants.slice(this.FirstTableItemIndex, this.LastTableItemIndex);
        this.loadStatus = `Loading ${participantsToDisplay.length} Participants...`;
        const completeParticipants: Array<EventParticipantDetails> = await Promise.all( participantsToDisplay.map(async(attendee) => {
            const attendeeDetails: EventParticipantDetails = new EventParticipantDetails().load(attendee);
            attendeeDetails.athlete = await this.AthleteRetrieve(attendee.attendeeId);
            attendeeDetails.purchase = await this.PurchaseRetrieve(attendee.purchaseId, attendee.attendeeId, this.baEvent.id);
            if( this.IsEmpty(attendee.purchaseId) ) attendee.purchaseId = attendeeDetails.purchase?.id;
            attendeeDetails.ticket = await this.baEvent.Ticket(attendee.ticketId);
            attendeeDetails.id = attendeeDetails.athlete?.id;
            if( this.showBARating ) await attendeeDetails.fetchBARating();
            else attendeeDetails.recruitingProfile = await this.RecruitingProfileRetrieve(attendeeDetails.id);
            attendeeDetails.data = await this.AthleteDataRetrieve(attendeeDetails.id, attendeeDetails.Data);
            attendeeDetails.tags = `${attendeeDetails.FullName} ${attendeeDetails.Email} ${attendeeDetails.Organization} ${attendeeDetails.TeamName} ${attendeeDetails.id}`.toLowerCase();
            
            return attendeeDetails;
        }));

        this.participants = completeParticipants;

        this.dataItems = this.participants;
        this.dataItemsCount = this.participants.length;
        this.loadStatus = "";
    }
    async loadTable() {
        this.isLoading = true;
        this.isLoaded = false;

        await this.loadParticipants();

        this.isLoaded = true;
        this.isLoading = false;
    }

    isCoachesLoading: boolean = false;
    isCoachesLoaded: boolean = false;
    coaches: Array<CoachProfileModel> = [];
    async loadCoachesTable() {
        this.isCoachesLoading = true;
        this.isCoachesLoaded = false;

        this.coaches = [];

        if( this.IsNotEmpty(this.baEvent?.coaches) ) {
            this.coaches = await Promise.all(this.baEvent.coaches.map(async(coachId) => {
                const coach = await coachApi.findById(coachId);
                return coach;
            }))
        }

        this.isCoachesLoaded = true;
        this.isCoachesLoading = false;
    }

    allEvents: Array<BAEventModel>;
    async loadAllEvents() {
        let query: RepositoryQuery<BAEventModel> = { $match: { registration: true } }
        const response = await baEventApi.queryAll(query)
        this.allEvents = response.docs;
    }
    async mounted() {
        await this.loadAllEvents();
        await this.loadLocations();
        await this.loadEvent();
        this.tableOptions.itemsPerPage = 5;
    }

    get eventId(): string {        
        return this.$route.params.eventId;
    }

    locationsCache: ObjectCache<EventLocationModel> = new ObjectCache<EventLocationModel>();
    allLocations: Array<EventLocationModel> = [];
    isLoadingLocations: boolean = false;
    async loadLocations() {
        this.isLoadingLocations = true;
        const response = await eventLocationApi.queryAll({});
        this.allLocations = response.docs;
        this.locationsCache.setMultiple(this.allLocations);
        this.isLoadingLocations = false;
    }
	get Locations(): EventLocationModel[] {
		return this.allLocations;
	}
	onChangeUnlimitedCapacity() {
		this.editEvent.capacity = this.unlimitedCapacity? -1 : (( this.baEvent.capacity < 0 )? 100 : this.baEvent.capacity );
	}

    async loadEvent(): Promise<BAEventModel> {
        this.loadingEvent = true;
        this.baEvent = undefined;
        this.baEvent = await baEventApi.findById(this.eventId);
        this.baEvent.loadEx(this.locationsCache);
        this.editEvent = new BAEventModel().load(this.baEvent);
        this.editEvent.loadEx(this.locationsCache);
        this.loadParticipants();
        if( this.IsNotEmpty(this.editEvent.prerequisite) ) this.prerequisite = this.allEvents.find(e => e.id === this.editEvent.prerequisite);
        this.loadingEvent = false;
        return this.baEvent;
    }

    editingName: boolean = false;
    editingDate: boolean = false;
    editingLocation: boolean = false;
    editingCapacity: boolean = false;
    editingWebsite: boolean = false;
    editingShowcase: boolean = false;
    editingPrerequisite: boolean = false;
    editingRegistration: boolean = false;
    editingInvitational: boolean = false;
    editingProcessingFee: boolean = false;
    editingWeblinks: boolean = false;
    editingDescription: boolean = false;
    editingPhoto: boolean = false;
    editingLabels: boolean = false;
    editingTickets: boolean = false;
    editedTickets: boolean = false;
    editedCoaches: boolean = false;
    editEventDate: Date;
    editEventTime: string;
    editStartDate: Date;
    editStartTime: string;
    editEndDate: Date;
    editEndTime: string;
    showActions: boolean = true;
    get IsEditing() {
        return( 
            this.editingName || 
            this.editingDate || 
            this.editingLocation || 
            this.editingCapacity || 
            this.editingWebsite || 
            this.editingShowcase || 
            this.editingPrerequisite || 
            this.editingRegistration || 
            this.editingInvitational ||
            this.editingProcessingFee ||
            this.editingWeblinks ||
            this.editingDescription || 
            this.editingPhoto || 
            this.editingLabels || 
            this.editingTickets || 
            this.editedTickets ||
            this.editedCoaches
        );
    }
    onEditDate() {
        this.editEventDate = new Date(this.editEvent.date.toDateString());
		this.editEventTime = this.getTime(this.editEvent.date);
        this.editingDate = true;
    }
    onEditLocation() {
        this.selectLocation = this.editEvent.Location;
        this.editingLocation = true;
    }
    onEditCapacity() {
        this.unlimitedCapacity = (this.editEvent.capacity < 0);
        this.editingCapacity = true;
    }
    onEditWebsite() {
        this.editingWebsite = true;
    }
    onEditRegistration() {
        this.editEvent.registration = true;
        this.onToggleRegistration();
    }
    onEditInvitational() {
        this.editEvent.invitational = true;
        this.onToggleInvitational();
    }
    onEditShowcase() {
        this.editEvent.showcase = true;
        this.onToggleShowcase();
    }
    onEditProcessingFee() {
        this.editEvent.addProcessingFee = true;
        this.onToggleProcessingFee();
    }
    onToggleShowcase() {
        this.editStartDate = new Date(this.editEvent.showcaseStart.toDateString());
		this.editStartTime = this.getTime(this.editEvent.showcaseStart);
        this.editEndDate = new Date(this.editEvent.showcaseEnd.toDateString());
		this.editEndTime = this.getTime(this.editEvent.showcaseEnd);
        this.editingShowcase = true;
    }
    onToggleRegistration() {
        this.editingRegistration = true;
    }
    onToggleInvitational() {
        this.editingInvitational = true;
    }
    onToggleProcessingFee() {
        this.editingProcessingFee = true;
    }
    onToggleAllDay() {
        this.editingDate = true;
    }
    onEditDescription() {
        this.editingDescription = true;
    }
    onEditPhoto() {
        this.editingPhoto = true;
    }
    clearEditing() {
        this.editingName = false;
        this.editingDate = false;
        this.editingLocation = false;
        this.editingCapacity = false;
        this.editingWebsite = false;
        this.editingShowcase = false;
        this.editingPrerequisite = false;
        this.editingRegistration = false;
        this.editingInvitational = false;
        this.editingProcessingFee = false;
        this.editingWeblinks = false;
        this.editingDescription = false;
        this.editingPhoto = false;
        this.editingLabels = false;
        this.editingTickets = false;
        this.editedTickets = false;
        this.editedCoaches = false;
    }
    onCancelEdit() {
        if( !this.IsEditing ) this.gotoEventsAdmin();

        this.editEvent = new BAEventModel().load(this.baEvent);
        this.clearEditing();
        this.clearStatus();
    }
    async saveEvent() {
        this.savingEvent = true;
        this.clearEditing();
        this.editingTicketType = false;
        this.addingTicketType = false;

        await baEventApi.save(this.editEvent);
        this.loadEvent();
        this.savingEvent = false;
    }
    async onSaveEdit() {
        if( this.editingDate ) {
		    this.editEvent.date = new Date(this.formatDateSlashesYYYYMMDD(this.editEventDate, true) + ` ${this.editEventTime}`);
        }
        if( this.editingShowcase ) {
            this.editEvent.showcaseStart = new Date(this.formatDateSlashesYYYYMMDD(this.editStartDate, true) + ` ${this.editStartTime}`);
            this.editEvent.showcaseEnd = new Date(this.formatDateSlashesYYYYMMDD(this.editEndDate, true) + ` ${this.editEndTime}`);
        }
        if( this.editingLocation ) {
		    this.editEvent.location = this.selectLocation.id;
        }
        if( this.editingCapacity ) {
            if( this.unlimitedCapacity ) this.editEvent.capacity = -1;
        }
        await this.saveEvent()
    }

    $refs:{ ticketTypeForm: HTMLFormElement, couponForm: HTMLFormElement }
    editingTicketType: boolean = false;
    backupTicketType: EventTicketModel;
    editTicketType: EventTicketModel;
    editTicketTypeTitle: string = "New Ticket Type"
    editTicketTypeHasName: boolean = false;
    addingTicketType: boolean = false;
    ticketFree: boolean = false;
    ticketUnlimitedCapacity: boolean = false;
    startEditTicketType() {
        this.ticketUnlimitedCapacity = (this.editTicketType.capacity < 0);
        this.editTicketTypeHasName = this.IsNotEmpty(this.editTicketType.name);
        this.editingTicketType = true;
    }
    onTicketTypeChangeName() {
        this.editTicketTypeHasName = true;
    }
    async onTicketTypeAddStandard() {
        await this.onTicketTypeAdd('VIP');
        this.editEvent.tickets.push(this.editTicketType);
        await this.onTicketTypeAdd('GA');
    }
    async onTicketTypeAdd(type?: string) {
        this.editTicketTypeTitle = "New Ticket Type";
        this.editTicketType = new EventTicketModel(type);
        this.addingTicketType = true;
        this.startEditTicketType();
    }
    async onTicketTypeEdit(ticketType: EventTicketModel) {
        this.editTicketTypeTitle = `Edit ${ticketType.name}`;
        this.backupTicketType = cloneDeep(ticketType);
        this.editTicketType = ticketType;
        this.startEditTicketType();
    }
    async onTicketTypeDelete(ticketType: EventTicketModel) {
        if( !confirm(`Delete ${ticketType.name} Ticket? This action cannot be undone`) ) return;

        this.showActions = false;
        const editTicket = this.editEvent.tickets.find(t => t.stripeId === ticketType.stripeId);
        editTicket.deleted = true;
        ticketType.deleted = true;
        this.editedTickets = true;
        this.showActions = true;
    }
    async onTicketTypeToggleHide(ticketType: EventTicketModel) {
        this.showActions = false;
        const editTicket = this.editEvent.tickets.find(t => t.name === ticketType.name);
        ticketType.hidden = !ticketType.hidden;
        editTicket.hidden = ticketType.hidden;
        this.editingTickets = true;
        this.showActions = true;
    }
    async onTicketTypeToggleDisable(ticketType: EventTicketModel) {
        this.showActions = false;
        const editTicket = this.editEvent.tickets.find(t => t.name === ticketType.name);
        ticketType.disabled = !ticketType.disabled;
        editTicket.disabled = ticketType.disabled;
        this.editingTickets = true;
        this.showActions = true;
    }
    async onTicketTypeEditCancel() {
        if( this.IsNotEmpty(this.backupTicketType) ) {
            const index = this.editEvent.tickets.findIndex(t => t.stripeId === this.backupTicketType.stripeId);
            if( index >= 0 ) Object.assign(this.editEvent.tickets[index], this.backupTicketType);
            Object.assign(this.editTicketType, this.backupTicketType);
        }
        this.clearStatus();
        this.editingTicketType = false;
        this.addingTicketType = false;
    }
    async onTicketTypeSaveConfirm() {
        if( !this.$refs.ticketTypeForm.validate() ) {
            this.setError( "Please complete all of the required fields" );
            return;
        }

        if( this.addingTicketType ) {
            if( this.IsEmpty( this.editTicketType.price ) ) {
                this.editTicketType.price = 0;
                this.editTicketType.priceUS = 0;
            }
            this.editEvent.tickets.push(this.editTicketType);
            await this.saveEvent();
        } else if( this.editingTicketType ) {
            const editTicket = this.editEvent.tickets.find(t => t.stripeId === this.editTicketType.stripeId);
            editTicket.name = this.editTicketType.name;
            editTicket.description = this.editTicketType.description;
            editTicket.coupons = this.editTicketType.coupons;
            this.editedTickets = true;
            this.editingTicketType = false;
        }
    }
    async onTicketChangeUnlimitedCapacity() {
        this.editTicketType.capacity = this.ticketUnlimitedCapacity? -1 : ((!this.backupTicketType || this.backupTicketType.capacity < 0 )? 32 : this.backupTicketType.capacity);
        this.editTicketType.setRemaining();
    }
    async onTicketChangeFree() {
        this.editTicketType.price = this.ticketFree? 0 : ((!this.backupTicketType || this.backupTicketType.price < 1)? 395 : this.backupTicketType.price);
        this.editTicketType.priceUS = this.ticketFree? 0 : ((!this.backupTicketType || this.backupTicketType.priceUS < 1)? 395 : this.backupTicketType.priceUS);
    }

    attendeeTicket: EventTicketModel;

    addingTeam: boolean = false;
    addingTeamInProgress: boolean = false;
    teamToAdd: TeamModel = null;
    async onTeamAddStart() {
        this.teamToAdd = null;
        this.attendeeTicket = new EventTicketModel;
        this.addingTeam = true;
    }
    async onTeamAddConfirm(team: TeamModel) {
        if( this.IsEmpty(team) ) return;

        this.addingTeamInProgress = true;
        for( const player of team.players ) {
            // player is of type PlayerOnTeam
            if( !player.athleteId ) continue;
            if( this.editEvent.participants.find(a => a.attendeeId === player.athleteId) ) continue;

            const athlete: AthleteProfileModel = await athleteApi.findById(player.athleteId);
            if( this.IsNotEmpty(athlete) ) {
                await this.addAttendee(athlete);
            }
        }
        await this.saveEvent();
        this.addingTeamInProgress = false;
        this.addingTeam = false;
    }
    async onSelectTeamToAdd(team: TeamModel) {
        this.teamToAdd = team;
    }

    async addAttendee(athlete: AthleteProfileModel): Promise<boolean> {
        try {
            if( this.editEvent.participants.find(p => p.attendeeId === athlete.id) ) {
                notificationStore.pushSnackbarWarning({message: `Athlete not added. ${athlete.FullName} is already attending this event.`})
                return false;
            }

            // create the purchase request
            const data: Record<string,any> = this.PurchaseAthleteData(this.editEvent.dataLabels, athlete);
            this.purchaseRequest = new BAPurchaseModel().load({
                parentId: athlete.id,
                productId: this.editEvent.id,
                priceId: this.attendeeTicket.id,
                date: new Date(),
                requested: false,
                completed: true,
                data
            })
            await this.savePurchaseRequest();

            // complete the purchase
            const completedPurchase: BAPurchaseModel = await baEventApi.addParticipant(this.editEvent.id, this.attendeeTicket.id, athlete.id);

            // add attendee to event
            await this.editEvent.addAttendee(athlete, this.attendeeTicket);

            this.waitForStripe = false;

            notificationStore.pushSnackbarSuccess({message: `${athlete.FullName} added to this event.`});
            return true;
        } catch(e) {
            notificationStore.pushSnackbarError({message: `Error Adding Athlete: ${e}`});
        }
    }

    addingAttendee: boolean = false;
    attendeeToAdd: AthleteProfileModel = null;
    async onAttendeeAddStart() {
        this.attendeeToAdd = null;
        this.attendeeTicket = new EventTicketModel;
        this.addingAttendee = true;
    }
    async onAttendeeAddComplete(athlete: AthleteProfileModel) {
        if( await this.addAttendee(athlete) ) {
            await this.saveEvent();
        }
        this.addingAttendee = false;
    }
    async onSelectAttendeeToAdd(athlete: AthleteProfileModel) {
        this.attendeeToAdd = athlete;
    }

    viewCoaches: boolean = false;
    allCoaches: Array<CoachProfileModel> = [];
    isAllCoachesLoading: boolean = false;
    isAllCoachesLoaded: boolean = false;
    addingCoach: boolean = false;
    selectingCoach: boolean = false;
    coachToAdd: CoachProfileModel;
    async onToggleViewCoaches() {
        this.viewCoaches = !this.viewCoaches;
        if( this.viewCoaches ) await this.loadCoachesTable();
    }
    async onCoachAddBegin() {
        if( this.IsEmpty(this.allCoaches) ) {
            this.isAllCoachesLoaded = false;
            this.isAllCoachesLoading = true;
            this.allCoaches = await coachApi.findAllWithAccess();
            this.isAllCoachesLoading = false;
            this.isAllCoachesLoaded = true;
        }
        this.coachToAdd = undefined;
        this.addingCoach = true;
    }
    onCoachSelect(coach: CoachProfileModel) {
        this.selectingCoach = true;
        this.coachToAdd = coach;
        this.selectingCoach = false;
    }
    onCoachAddCancel() {
        this.clearStatus();
        this.coachToAdd = undefined;
        this.addingCoach = false;
    }
    async onCoachAddComplete() {
        if( this.IsNotEmpty(this.coachToAdd) ) {
            this.baEvent.coaches.push(this.coachToAdd.id);
            const coachAdded = await baEventApi.patch({id: this.baEvent.id, coaches: this.baEvent.coaches});
            if( this.IsNotEmpty(coachAdded) ) this.loadCoachesTable();
        }
        this.coachToAdd = undefined;
        this.addingCoach = false;
        this.editedCoaches = true;
    }
    onCoachDelete(coach: CoachProfileModel) {
        if( !confirm(`Delete coach ${coach.FullName}?`) ) return;

        if( this.IsEmpty(coach) ) return;
        const index = this.baEvent.coaches.findIndex(c => c === coach.id);
        if( index < 0 ) return;
        this.baEvent.coaches.splice(index, 1);
        this.editedCoaches = true;
        this.loadCoachesTable();
    }

    viewParticipants: boolean = false;
    viewParticipantsDetail: boolean = false;
    async onParticipantsExpand() {
        this.viewParticipants = true;
        await this.loadTable();
    }
    async onParticipantsCollapse() {
        this.viewParticipants = false;
    }
    async onParticipantsDelete() {
        if( !confirm(`Delete ALL participants? This action cannot be undone`) ) return;

        const success = await this.editEvent.deleteAllParticipants();
        if( success ) await this.saveEvent();
    }
    async onAttendeeDelete(attendeeDetails: EventParticipantDetails) {
        if( !confirm(`Delete ${attendeeDetails.FullName}'s ${attendeeDetails.Ticket} Ticket? This action cannot be undone`) ) return;

        // remove purchase
        try {
            this.deletePurchase(attendeeDetails.attendeeId, this.editEvent.id, attendeeDetails.ticketId);
        } catch(e) {
            console.error(`Unable to delete purchase for: ${attendeeDetails.attendeeId}`)
            // continue
        }

        // remove attendee from this event
        try {
            const success = await this.editEvent.deleteAttendee(attendeeDetails);
            if( success ) await this.saveEvent();
        } catch(e) {
            console.error(`Unable to delete attendee ${attendeeDetails.FullName}: `, e)
        }
    }

    async onAttendeeSync(attendeeDetails: EventParticipantDetails) {
        const athlete: AthleteProfileModel = await athleteApi.findById(attendeeDetails.athlete?.id);
        if( this.IsEmpty(athlete) ) return;
    }

    async exportCSVFromParticipants(filename: string): Promise<void> {
        const normalizeKey = (key: string): string => {
            return key.toLowerCase().replace(/[^a-z0-9]/g, "");
        };
        const isNotEmptyData = (data: any): boolean => {
            const str = String(data ?? '').toString();
            if( this.IsEmpty(str) ) return false;
            else if( str.trim() === "" ) return false;
            else if( str.trim() === "-" ) return false;
            else if( str.trim() === "--" ) return false;
            return true;
        };

        // create header labels composed of all the 'data' participants have filled out
        const dataLabels = new Set<string>();
        this.baEvent.dataLabels.forEach(label => dataLabels.add(label));
        this.participants.forEach(p => {
            const participantKeys = Object.keys(p.Data());
            participantKeys.forEach(key => {
                const existingLabels = Array.from(dataLabels);
                const existingKey = existingLabels.find(l => normalizeKey(l) === normalizeKey(key));
                if( this.IsEmpty(existingKey) ) dataLabels.add(key)
            });
        })
        
        const headerLabels = Array.from(dataLabels);
        // const headers = ['Name','email','organization','team','position','baRating','archetype','link','photo',...headerLabels];
        const headers = [...headerLabels,'Name','Profile Link','Team','Organization','Mindset Archetype','Registration Date'];
        const rows = this.participants.map(p => {
            const pData = p.Data(this.baEvent.dataLabels, p.purchase?.data);
            const participantKeys = Object.keys(pData);
            // obtain data for each header label
            const participantData = headerLabels.map(h => {
                const key = participantKeys.find(k => this.NormalizeString(k) === this.NormalizeString(h));
                if( this.IsNotEmpty(key) ) return this.escapeCSV(pData[key]);
                return " - ";
            })
            // add 'Name','Profile Link','Mindset Archetype'
            const hasMindset = this.IsNotEmpty(p.recruitingProfile?.mindsetReport) && !p.recruitingProfile?.mindsetReport.HasError;
            participantData.push(...[
                this.escapeCSV(p.FullName),
                this.escapeCSV(`${this.PublicLink}${p.athlete?.PublicSharingUrl}`),
                this.escapeCSV(p.TeamName),
                this.escapeCSV(p.Organization),
                this.escapeCSV(hasMindset? p.recruitingProfile?.mindsetReport.archetype : ''),
                this.escapeCSV(p.purchase? p.purchase.date : ''),
            ]);
            return participantData;
        })

        const csvContent = [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    }

    onParticipantsExport() {
        this.exportCSVFromParticipants(`event-participants-${this.editEvent.name}-BA.csv`);
    }

    newAgreement: AgreementFile = new AgreementFile('My Agreement');
    newAgreementIndex: number = 1;
    agreementUnderPreview: AgreementFile;
    agreementPreview: boolean = false;
    onAgreementsRemoveAll() {
        this.editEvent.agreements = [];
    }
    onAgreementRemove(index: number) {
        this.editEvent.agreements.splice(index, 1);
    }
    async onAgreementNewConfirm() {
        if( this.IsEmpty(this.newAgreement) ) return;
        this.editEvent.agreements.push(this.newAgreement);
        await this.saveEvent();
        this.newAgreementIndex++;
        this.newAgreement = new AgreementFile(`My Agreement ${this.newAgreementIndex}`);
    }
    async onAgreementEditConfirm() {
        await this.saveEvent();
    }
    async onAgreementPreview(agreement) {
        this.agreementUnderPreview = agreement;
        await this.agreementUnderPreview.read();
        this.agreementPreview = true;
    }
    onAgreementClosePreview() {
        this.agreementPreview = false;
    }

    newDataLabel: string = '';
    onDataLabelsRemoveAll() {
        this.editEvent.dataLabels = [];
    }
    onDataLabelRemove(index: number) {
        this.editEvent.dataLabels.splice(index, 1);
        this.editingLabels = true;
    }
    onDataLabelNewConfirm() {
        if( this.IsEmpty(this.newDataLabel) ) return;
        if( this.editEvent.dataLabels.includes(this.newDataLabel) ) return;

        const commentsIndex = this.editEvent.dataLabels.indexOf('Comments');
        if( commentsIndex > 0 ) {
            this.editEvent.dataLabels.splice(commentsIndex, 0, this.newDataLabel);
        } else {
            this.editEvent.dataLabels.push(this.newDataLabel);
        }
        this.editingLabels = true;
    } 

    editLabels: boolean = false;
    labelToEdit: number = undefined;
    refreshLabels: boolean = false;
    onDataLabelsEdit() {
        this.editLabels = true;
    }
    onDataLabelsEditCancel() {
        this.editLabels = false;
    }
    async onDataLabelsEditAccept() {
        this.editLabels = false;
        await this.saveEvent();
    }
    async onDataLabelDelete(index: number) {
        this.refreshLabels = true;
        await this.editEvent.dataLabels.splice(index, 1);
        this.refreshLabels = false;
    }
    onDataLabelEdit(index: number) {
        this.refreshLabels = true;
        this.labelToEdit = index;
        this.refreshLabels = false;
    }
    onDataLabelEditAccept() {
        this.refreshLabels = true;
        this.labelToEdit = undefined;
        this.refreshLabels = false;
    }
    onDataLabelMoveUp(index: number) {
        this.refreshLabels = true;
        if( index < 1 ) return;

        const temp = this.editEvent.dataLabels[index - 1]
        this.editEvent.dataLabels[index - 1] = this.editEvent.dataLabels[index];
        this.editEvent.dataLabels[index] = temp;
        this.refreshLabels = false;
    }
    onDataLabelMoveDown(index: number) {
        this.refreshLabels = true;
        if( ( index < 0 ) || ( index > this.editEvent.dataLabels.length - 2 ) ) return;

        const temp = this.editEvent.dataLabels[index + 1]
        this.editEvent.dataLabels[index + 1] = this.editEvent.dataLabels[index];
        this.editEvent.dataLabels[index] = temp;
        this.refreshLabels = false;
    }
    onDataLabelsSetToSoccer() {
        this.editEvent.dataLabels = [
            'First Name',
            'Last Name',
            'Email',
            'Phone Number',
            'Instagram ID',
            'Address',
            'Address 2',
            'City',
            'State',
            'Country',
            'Zip Code',
            'Date of Birth',
            'Weight lbs',
            'Height ft in',
            'Gender',
            'Current Club',
            'Current Team',
            'Club Coach',
            'Coach Email',
            'Primary Position',
            'Secondary Position',
            'School Name',
            'Grade',
            'Graduation Year',
            'GPA',
            'SAT',
            'Guardian Name',
            'Guardian Phone',
            'Guardian Email',
            'Emergency Contact',
            'Emergency Contact Phone',
            'Emergency Contact Email',
            'Medical Insurance Company',
            'Medical Insurance Policy Holder',
            'Medical Insurance Policy Number',
            'Medical Insurance Phone',
            'Adult Shirt Size',
            'Adult Short Size',
            'Comments'
        ]
    }
    onDataLabelsSetToRugby() {
        this.editEvent.dataLabels = [
            'First Name',
            'Last Name',
            'Email',
            'Phone Number',
            'Instagram ID',
            'Address',
            'Address 2',
            'City',
            'State',
            'Country',
            'Zip Code',
            'Date of Birth',
            'Weight lbs',
            'Height ft in',
            'Team Gender',
            'USA Rugby ID Number',
            'Years Played Rugby',
            'Current Rugby Club',
            'Rugby Club Coach',
            'Rugby Coach Email',
            'Primary Position 15s',
            'Secondary Position 15s',
            'Primary Position 7s',
            'Secondary Position 7s',
            'School Name',
            'Grade',
            'Graduation Year',
            'GPA',
            'SAT',
            'Guardian Name',
            'Guardian Phone',
            'Guardian Email',
            'Emergency Contact',
            'Emergency Contact Phone',
            'Emergency Contact Email',
            'Medical Insurance Company',
            'Medical Insurance Policy Holder',
            'Medical Insurance Policy Number',
            'Medical Insurance Phone',
            'Adult Shirt Size',
            'Adult Short Size',
            'Comments'
        ]
    }

    newCoupon: boolean = false;
    editCoupon: EventTicketCoupon;
    backupCoupon: EventTicketCoupon;
    showCouponDialog: boolean = false;
    showCouponInfo: boolean = true;
    onCouponAddBegin() {
        this.editCoupon = new EventTicketCoupon();
        this.showCouponInfo = this.editCoupon.discountType !== CouponDiscountType.show;
        this.newCoupon = true;
        this.showCouponDialog = true;
    }
    onCouponEditBegin(coupon: EventTicketCoupon) {
        this.editCoupon = coupon;
        this.backupCoupon = new EventTicketCoupon().load(this.editCoupon);
        this.onCouponChangeType(this.editCoupon.discountType);
        this.showCouponDialog = true;
    }
    onCouponChangeType(discountType: CouponDiscountType) {
        this.showCouponInfo = discountType !== CouponDiscountType.show;
    }
    onCouponCancel() {
        if( this.IsNotEmpty(this.backupCoupon) ) {
            Object.assign(this.editCoupon, this.backupCoupon);
            this.backupCoupon = undefined;
        }
        this.clearStatus();
        this.newCoupon = false;
        this.showCouponDialog = false;
    }
    onCouponConfirm() {
        if( !this.$refs.couponForm.validate() ) {
            this.setError( "Please complete all of the required fields" );
            return;
        }

        if( this.newCoupon ) {
            this.editTicketType.coupons.push(this.editCoupon);
        }
        this.clearStatus();
        this.newCoupon = false;
        this.showCouponDialog = false;
    }
    onCouponDelete(coupon: EventTicketCoupon) {
        if( !confirm(`Delete ${this.editCoupon.name} Ticket? This action cannot be undone`) ) return;

        const index = this.editTicketType.coupons.findIndex(c => c.name === coupon.name);
        if( index >= 0 ) this.editTicketType.coupons.splice(index, 1);

        this.clearStatus();
        this.showCouponDialog = false;        
    }
    get CouponDiscountTypes(): Array<string> {
        return Object.values(CouponDiscountType);
    }

    prerequisite: BAEventModel;
    onPrerequisiteChange(event: BAEventModel) {
        this.editingPrerequisite = true;
        this.editEvent.prerequisite = event.id;
    }

	onEventPreview() {
		this.$router.push({
			name: BAEventDetail,
			params: { eventId: this.baEvent.id }
		});
	}

	isWeblinksChanging: boolean = false;
	onWeblinkAdd(event: any) {
		this.isWeblinksChanging = true;
		if( this.IsEmpty(event.weblinks) ) event.weblinks = [];
		event.weblinks.unshift({label:'', url:''});
		this.editingWeblinks = true;
		this.isWeblinksChanging = false;
	}
	onWeblinkDelete(index: number, event: any) {
		this.isWeblinksChanging = true;
		event.weblinks.splice(index, 1);
		this.editingWeblinks = true;
		this.isWeblinksChanging = false;
	}
	onWeblinkChange() {
		this.isWeblinksChanging = true;
		this.editingWeblinks = true;
		this.isWeblinksChanging = false;
	}
}
